/** 运维接口 —— docs/04 §7 */

import type { HealthResponse, QueueStats, ReadyResponse, WorkerInfo } from '@/types/api';
import { http } from './client';

export function getHealth(signal?: AbortSignal) {
  return http.get<HealthResponse>('/health', undefined, signal);
}

export function getReady(signal?: AbortSignal) {
  return http.get<ReadyResponse>('/ready', undefined, signal);
}

export function listWorkers(signal?: AbortSignal) {
  return http.get<{ items: WorkerInfo[] }>('/workers', undefined, signal);
}

export function getQueueStats(signal?: AbortSignal) {
  return http.get<QueueStats>('/queue/stats', undefined, signal);
}

/** 队列积压告警阈值：oldest_pending_age_ms 持续上升说明 Worker 消费不过来（docs/04 §7） */
export const QUEUE_AGE_WARN_MS = 30_000;
export const QUEUE_AGE_DANGER_MS = 120_000;
